import React, { Component } from 'react';
import { Form, Formik } from 'formik'
import onboarding from 'assets/images/onboarding.png'
import RouteConst from '../../../../constants/RouteConst'
import * as FormConst from '../../../../constants/FormConst'
import Button from '../../../atoms/Button/Button'
import FormModal from '../../../organisms/FormModal/FormModal'
import RatePlanConfigurationService from '../../../../services/RatePlanConfigurationService'
import { isArrayNotEmpty } from '../../../../utilities/JSUtil'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import ToggleSwitch from '../../../atoms/form/ToggleSwitch/ToggleSwitch'
import * as Yup from 'yup';
import './RatePlanConfiguration.scss';

export class RatePlanConfiguration extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ratePlans: [],
            isAdd: false,
            isEdit: false,
            isDelete: false,
            isLoading: true,
            showErrorModal: false,
            errorMessage: undefined,
            currentRatePlan: undefined,
            currentRatePlanIndex: undefined
        }

    }

    // To submit the add and edit forms from the form modal buttons which is outside of formik
    submitForm = null;

    handleSubmitForm = (data) => {
        if (this.submitForm) {
            this.submitForm(data);
        }
    }

    bindSubmitForm = (submitForm) => {
        this.submitForm = submitForm;
    }

    validationSchema = Yup.object().shape({
        code: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(FormConst.RATE_PLAN_CODE_MAX_LENGTH, `Up to ${FormConst.RATE_PLAN_CODE_MAX_LENGTH} characters allowed`),
    })

    async componentDidMount() {
        await RatePlanConfigurationService.getConfigurableRatePlans()
            .then((response) => {
                this.setState({
                    ratePlans: response,
                    isLoading: false
                })
            })
            .catch(() => {
                this.setState({
                    isLoading: false, 
                    showErrorModal: true,
                    errorMessage: 'Error while fetching rate plans.'
                })
            })
    }
    
    doAdd = (data) => {
        this.setState({ isAdd: false, isLoading: true })
        data.code = data.code.trim().toUpperCase()

        RatePlanConfigurationService.addConfigurableRatePlan(data)
            .then(() => {
                let ratePlans = [...this.state.ratePlans]
                ratePlans.push(data)
                this.setState({
                    ratePlans: ratePlans,
                    isLoading: false
                });
            }).catch((error) => {
                let msg = 'Error while adding rate plan.'
                if (error.messages[0].code === 'MASTER_RATE_PLAN_ALREADY_EXISTS') {
                    msg = 'Error while adding rate plan. Rate plan with the same code already exists.'
                }
                this.setState({
                    showErrorModal: true,
                    errorMessage: msg,
                    isLoading: false
                })
            })
    }

    doUpdate = (data) => {
        this.setState({ isEdit: false, currentRatePlan: undefined, isLoading: true })

        RatePlanConfigurationService.updateConfigurableRatePlan(data)
            .then(() => {
                let ratePlans = [...this.state.ratePlans]
                ratePlans[this.state.currentRatePlanIndex] = data
                this.setState({
                    ratePlans: ratePlans,
                    currentRatePlanIndex: undefined,
                    isLoading: false
                });
            }).catch(() => {
                this.setState({
                    showErrorModal: true,
                    errorMessage: 'Error while updating rate plan.',
                    currentRatePlanIndex: undefined,
                    isLoading: false
                })
            })
    }

    doDelete = () => {
        this.setState({ isDelete: false, isLoading: true })
        const code = this.state.ratePlans[this.state.currentRatePlanIndex].code

        RatePlanConfigurationService.deleteConfigurableRatePlan(code)
            .then(() => {
                let ratePlans = [...this.state.ratePlans]
                ratePlans.splice(this.state.currentRatePlanIndex, 1);
                this.setState({
                    ratePlans: ratePlans,
                    currentRatePlanIndex: undefined,
                    isLoading: false
                });
            }).catch(() => {
                this.setState({
                    showErrorModal: true,
                    errorMessage: 'Error while deleting rate plan.',
                    currentRatePlanIndex: undefined,
                    isLoading: false
                })
            })
    }

    redirectToConfigure = () => {
        this.props.history.push(RouteConst.ROUTE_LAUNCH_CONFIGURE_PAGE)
    }

    render() {
        return (
            <div className='rate-plan-configuration-page'>
                <img id='page-logo' src={onboarding} className='onboarding-img' />
                
                <div className='rate-plans'>

                    <Button 
                        id='configure-page-button' 
                        name='Go to configuration page' 
                        className='configure-button' 
                        onClick={this.redirectToConfigure} />
                            
                    <p id='rate-plan-page-info' className='rate-plans-header'>{FormConst.MODAL_RATE_PLAN_TITLE}</p>

                    <div className='rate-plan-buttons'>
                        <Button 
                            id='rate-plan-add-button' 
                            name={'(+) Add Rate Plan'} 
                            className='add-button' 
                            onClick={() => this.setState({ isAdd: true })} />
                    </div>

                    <table id='rate-plans-table' className='table table-striped rate-plans-table'>
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Allow Seasons</th>
                                <th>Allow Blackouts</th>
                                <th>Display</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                isArrayNotEmpty(this.state.ratePlans)
                                    ? (
                                        this.state.ratePlans.map((ratePlan, index) =>
                                            <tr key={index}>
                                                <td>{ratePlan.code}</td>
                                                <td>{ratePlan.allowSeasons ? '1' : '0'}</td>
                                                <td>{ratePlan.allowBlackouts ? '1' : '0'}</td>
                                                <td>{ratePlan.display ? '1' : '0'}</td>
                                                <td><Button name={<FaEdit />} role='link' className='icon-link' 
                                                        onClick={() => this.setState({ isEdit: true, currentRatePlan: ratePlan, currentRatePlanIndex: index })}/>
                                                </td>
                                                <td><Button name={<FaTrashAlt />} role='link' className='icon-link' 
                                                        onClick={() => this.setState({ isDelete: true, currentRatePlanIndex: index })}/>
                                                </td>
                                            </tr>
                                        )
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={6} className='text-center'>No rate plans found.</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>

                    <Button 
                        id='configure-page-button' 
                        name='Go to configuration page' 
                        className='configure-button' 
                        onClick={this.redirectToConfigure} />

                    <FormModal
                        id='rate-plan-add-edit-modal'
                        title={FormConst.MODAL_RATE_PLAN_DETAILS}
                        body={
                            <div id='rate-plan-add-update'>
                                <Formik
                                    initialValues={{
                                        code: this.state.currentRatePlan ? this.state.currentRatePlan.code : "",
                                        allowSeasons: this.state.currentRatePlan ? this.state.currentRatePlan.allowSeasons : false,
                                        allowBlackouts: this.state.currentRatePlan ? this.state.currentRatePlan.allowBlackouts : false,
                                        display: this.state.currentRatePlan ? this.state.currentRatePlan.display : false
                                    }}
                                    validationSchema={this.validationSchema}
                                    onSubmit={(data, { setSubmitting }) => {
                                        setSubmitting(true)
                                        this.state.isEdit ? this.doUpdate(data) : this.doAdd(data)
                                        setSubmitting(false)
                                    }}>
                                    {(formikProps) => {
                                        const { values, handleChange } = formikProps;
                                        this.bindSubmitForm(formikProps.submitForm);

                                        return (
                                            <Form id='rate-plan-update-form'>
                                                <TextInput id='code' name='code' type='text' label='Code' autoCapitalize='characters' isrequired='true' 
                                                            onChange={handleChange} disabled={this.state.isEdit} style={{ 'text-transform': 'uppercase' }} />
                                                <ToggleSwitch
                                                    id='allowSeasons'
                                                    name='allowSeasons'
                                                    label='Allow Seasons'
                                                    checked={values.allowSeasons}
                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                    overridedisabledflag='true'
                                                    disabled={false}
                                                    onChange={handleChange} />

                                                <ToggleSwitch
                                                    id='allowBlackouts'
                                                    name='allowBlackouts'
                                                    label='Allow Blackouts'
                                                    checked={values.allowBlackouts}
                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                    overridedisabledflag='true'
                                                    disabled={false}
                                                    onChange={handleChange} />

                                                <ToggleSwitch
                                                    id='display'
                                                    name='display'
                                                    label='Display'
                                                    checked={values.display}
                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                    overridedisabledflag='true'
                                                    disabled={false}
                                                    onChange={handleChange} />
                                            </Form>
                                        )
                                    }}
                                </Formik>
                            </div>
                        }
                        show={this.state.isEdit || this.state.isAdd}
                        proceed={this.handleSubmitForm}
                        proceedName={FormConst.ACTION_SAVE}
                        cancel={() => this.setState({ isAdd: false, isEdit: false, currentRatePlan: undefined, currentRatePlanIndex: undefined }) }
                        hideLogo/>

                    <FormModal
                        id='rate-plan-delete-confirmation-modal'
                        title={FormConst.MODAL_RATE_PLAN_TITLE}
                        body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                        show={this.state.isDelete}
                        proceed={() => this.doDelete()} 
                        cancel={() => this.setState({ isDelete: false, currentRatePlan: undefined, currentRatePlanIndex: undefined }) }/>

                    <FormModal
                        id='rate-plan-page-loading-modal'
                        title={FormConst.MODAL_READ_ACTION_TITLE}
                        body={<h6>{FormConst.MODAL_READ_ACTION_TEXT}</h6>}
                        show={this.state.isLoading}
                        isLoadingIndicator />

                    <FormModal
                        id='rate-plan-page-error-modal'
                        title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                        body={<h5>{this.state.errorMessage}</h5>}
                        show={this.state.showErrorModal}
                        cancel={() => { this.setState({ showErrorModal: false, errorMessage: undefined }) }}
                        isError />

                </div>
            </div>
        )
    }
}

export default RatePlanConfiguration